export default "__VITE_ASSET__284d6462__"